var map = {
	"./en/btn_Synthesis_1.png": "gDzq",
	"./es/btn_Synthesis_1.png": "6JuT",
	"./pt/btn_Synthesis_1.png": "4UXI"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "yelh";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img ^\.\/.*\/btn_Synthesis_1\.png$
// module id = yelh
// module chunks = 0